import React from 'react';

/**
 * Calculates if the content is overflowing it element containing it
 * @param ref - ref of the DOM element which has a clientWidth and scrollWidth props
 * @param options
 * @returns {boolean} - True, if the content is overflowing, false otherwise.
 * @example
 * import { isContentOverflowingElement } from '@adsk/alloy-react-helpers';
 *
 * const ref = useRef<HTMLDivElement>(null);
 * const overflowed = isContentOverflowingElement(ref);
 * @see Tooltip
 */
export default function isContentOverflowingElement<T extends HTMLElement>(
  ref: React.RefObject<T | null>,
  options: { toleranceY: number } = { toleranceY: 0 },
): boolean {
  const target = ref?.current;
  if (target) {
    ['scrollWidth', 'offsetWidth', 'scrollHeight', 'offsetHeight'].forEach(
      (prop) => {
        if (!(prop in target)) {
          throw new Error(`Element does not have a ${prop} property`);
        }
      },
    );

    return (
      target.scrollWidth > target.offsetWidth ||
      target.scrollHeight > target.offsetHeight + options.toleranceY // + vertical tolerance in px to solve an issue with some fontSizes when clientHeight is slightly lower than the scrollHeight. See more: https://jira.autodesk.com/browse/DSGN-1757
    );
  }

  return false;
}
